// import variableColors from '@/base/global/variables/figma.colors.json';
// import variableTypography from '@/base/global/variables/figma.typography.json';
// import variableEffects from '@/base/global/variables/figma.effects.json';

export const dividerThemeToken: any = {
  // testToken1: variableColors["ColorFigmaChartsBlue"],
  // testToken2: variableTypography["FontFamilyFigmaCsoBodymedium"],
  // testToken3: variableEffects["EffectsFigmaElevationsElevation1"],
};
